<template>
  <div>
    <Modal :title="title" v-model="modalShow">
      <div class="req-form">
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="卷名称">
            <Input v-model="volumeData.name" :disabled="true" style="width: 300px" />
          </FormItem>
          <FormItem label="可启动" prop="bootable">
            <i-switch v-model="reqForm.bootable">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudVolume, detailPrivateCloudVolume } from '@/api/private-cloud/volume'
export default {
  name: 'volume-update-status',
  data () {
    return {
      title: '设置卷是否可启动',
      volumeData: {},
      modalShow: false,
      submitting: false,
      reqForm: {
        bootable: false
      },
      current_status: '',
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    openModal (id) {
      detailPrivateCloudVolume(id).then(res => {
        this.volumeData = res.data.volume
        if (this.volumeData) {
          if (this.volumeData.bootable === 'true' || this.volumeData.bootable === 'True') {
            this.reqForm.bootable = true
          } else {
            this.reqForm.bootable = false
          }
          this.modalShow = true
        } else {
          this.$Notice.error({
            title: '获取卷数据失败！'
          })
        }
      }).catch(res => {
        this.$Notice.error({
          title: '获取卷数据失败！',
          desc: res.request ? res.request.responseText : ''
        })
      })
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          let reqData = {}
          if (this.reqForm.bootable) {
            if (this.volumeData.bootable === 'true' || this.volumeData.bootable === 'True') {
              this.$Notice.error({
                title: '未作修改！'
              })
              return
            }
            reqData['os-set_bootable'] = {
              bootable: 'True'
            }
          } else {
            if (this.volumeData.bootable === 'false' || this.volumeData.bootable === 'False') {
              this.$Notice.error({
                title: '未作修改！'
              })
              return
            }
            reqData['os-set_bootable'] = {
              bootable: 'False'
            }
          }
          this.submitting = true
          actionPrivateCloudVolume(reqData, this.volumeData.id).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
